<div class="cardContent" [formGroup]="restrictiveUiForm">
    <div class="inputGroup">
        <label for="distributionCategory">{{ 'listings.userPreferences.restrictiveUi.type' | translate }}</label>
        <div class="inputWrapper">
            <app-form-error [parentForm]="restrictiveUiForm" [controlPath]="'distributionCategory'" />
            <select id="distributionCategory" formControlName="listingRestrictiveUIType">
                @for (listingRestrictiveUITypeOption of listingRestrictiveUITypeOptions(); track listingRestrictiveUITypeOption) {
                    <option [ngValue]="listingRestrictiveUITypeOption">
                        {{ listingRestrictiveUITypeOption.label }}
                    </option>
                }
            </select>
        </div>
    </div>

    @if (restrictiveUiForm.controls['listingRestrictiveUIType'].value?.value === userPreferenceRestrictiveUiType.CUSTOM) {
        <div class="inputGroup labelTop">
            <label for="listingRestrictiveUISelectedChannel">
                {{ 'listings.userPreferences.restrictiveUi.selectedChannels' | translate }}
            </label>
            <div class="inputWrapper">
                <app-form-error [parentForm]="restrictiveUiForm" [controlPath]="'distributionCategory'" />
                <select id="distributionCategory" formControlName="listingRestrictiveUISelectedChannel">
                    @for (channel of restrictiveUiChannels(); track channel) {
                        <option [ngValue]="channel">
                            {{ channel.label }}
                        </option>
                    }
                </select>
            </div>
        </div>
    }
</div>
<div class="cardFooter">
    <div class="buttonArea stickyBottom">
        <button type="submit" class="button primary" (click)="saveListingRestrictiveUIPreferences()">
            {{ 'generalKeywords.save' | translate }}
        </button>
        <button type="button" class="button" (click)="data.closeModal?.(undefined)">
            {{ 'generalKeywords.cancel' | translate }}
        </button>
    </div>
</div>
